import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Tabbles } from '../../../components'
import { PiClockUserLight, PiTrash } from 'react-icons/pi'
import { FiEdit } from 'react-icons/fi'
import { useTranslation } from 'react-i18next'

const CustomWorkingTime = ({ className, customAppointments, handleDeleteCustomWorkingTime, handleEditCustomWorkingTime, hiddenColumns }) => {
    const { t } = useTranslation();
    const filterColumns = (columns) =>
        columns.filter((column) => !hiddenColumns?.includes(column));
    const columns = [`${t("time_period")}`, `${t("day_off")}`, `${t("location")}`, `${t("working_hours")}`, `${t("lunch_break")}`, `${t("in_perpetuity")}`, `${t("Edit")}`, `${t("delete")}`];


    return (
        <Row className={className}>
            <Col md={12}>
                <Tabbles.TableBlk
                    headerIcon={<PiClockUserLight className="header-Icn" />}
                    heading={t("visiting_schedule.add_custom_working_time")}
                    columns={filterColumns(columns)}
                    data={customAppointments?.map((Appointment) => ({

                        [t("time_period")]: `${new Date(Appointment.fromDate).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        })} - ${new Date(Appointment.toDate).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        })}`,
                        [t("day_off")]: Appointment.isDayOff ? "Yes" : "No",
                        [t("location")]: Appointment.appointmentType === 1 ? "Online" :
                            Appointment.appointmentType === 2 ? "In - Clinic" : "Both",
                        [t("working_hours")]:
                            Appointment.workFromTime && Appointment.workToTime
                                ? `${new Date(Appointment.workFromTime).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                })} - ${new Date(Appointment.workToTime).toLocaleTimeString(
                                    [],
                                    { hour: "2-digit", minute: "2-digit" }
                                )}`
                                : "-",
                        [t("lunch_break")]:
                            Appointment.lunchFromTime && Appointment.lunchToTime
                                ? `${new Date(Appointment.lunchFromTime).toLocaleTimeString(
                                    [],
                                    { hour: "2-digit", minute: "2-digit" }
                                )} - ${new Date(Appointment.lunchToTime).toLocaleTimeString(
                                    [],
                                    { hour: "2-digit", minute: "2-digit" }
                                )}`
                                : "-",
                        [t("in_perpetuity")]: Appointment.isYearlyDayOff ? "Yes" : "No",
                        [t("Edit")]: (
                            <div className="editBlkIcon">
                                <FiEdit
                                    onClick={() => handleEditCustomWorkingTime(Appointment)}
                                    className="editIcon"
                                />
                            </div>
                        ),
                        [t("delete")]: (
                            <PiTrash
                                onClick={() => handleDeleteCustomWorkingTime(Appointment.customTimingGuid)}
                                className="delIcon noVerify"
                            />
                        ),
                    }))}

                    tabbleClassname="tabble"
                />
            </Col>
        </Row>
    )
}

export default CustomWorkingTime
